var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg","fill":"none","role":"img","aria-hidden":_vm.ariaHidden}},[_c('path',{attrs:{"d":"M3.75 10H16.25","stroke":_vm.computedStroke,"stroke-width":_vm.strokeWidth,"stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }